import PayrollIncomeEditComponents from "../components/PayrollIncomeEdit";
import useIncome from "../hooks/useIncome";

const PayrollIncomeEdit = () => {
  const useIncomeProps = useIncome();
  return <PayrollIncomeEditComponents {...useIncomeProps} />;
};

export default PayrollIncomeEdit;
